import React from "react";
import Lottie from "lottie-react";
import "../../styles/Loader.css";
import {ImagesPath}  from '../../Common/imagespath/imagespath';

const NtarLoader = () => {
  return (
    <div className="loader-container">
      <div className="lottie-wrapper">
        <Lottie animationData={ImagesPath?.ntarLoaders} loop={true} />
      </div>
    </div>
  );
};

export default NtarLoader;
